"use client"

import type { ReactNode } from "react"

import { cn } from "../../lib/utils"

type MobileBottomBarProps = {
  children: ReactNode
  className?: string
}

export function MobileBottomBar({ children, className }: MobileBottomBarProps) {
  return (
    <div
      className={cn(
        "fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-background/90 p-4 backdrop-blur-xl md:hidden",
        className
      )}
    >
      {children}
    </div>
  )
}
